/* Yadegari: opens the LeadConnector chat only after marketing consent or when the visitor asks for it. Also wires the footer "Cookie preferences" link. */
(() => {
  'use strict';
  if (window.yjChatConsentInstalled) return;
  window.yjChatConsentInstalled = true;
  const widgetId = '6ab8f888d8530f3af397c96c';
  const french = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
  const label = french ? 'Clavarder avec nous' : 'Chat with us';
  let loaded = false;
  let openAfterLoad = false;
  let launcher = null;
  const allowed = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || !privacy.marketingAllowed()) return false;
    const region = privacy.getRegion ? privacy.getRegion() : '';
    if (region && !region.startsWith('CA')) return true;
    const consent = privacy.currentVisitorConsent ? privacy.currentVisitorConsent() : {};
    return consent.marketing === 'yes';
  };
  function removeLauncher() {
    if (launcher) launcher.remove();
    launcher = null;
  }
  function load() {
    if (loaded) return;
    loaded = true;
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', widgetId);
    document.body.appendChild(script);
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      /* The loader waits for an interaction or 8 s. The click already happened, so tell it. */
      if (openAfterLoad) ['touchstart', 'wheel', 'scroll', 'mousemove', 'keydown'].forEach(name => {
        document.dispatchEvent(new Event(name));
      });
      const chat = window.leadConnector && window.leadConnector.chatWidget;
      if (chat && chat.openWidget) {
        clearInterval(timer);
        ready();
      } else if (tries > 40) {
        clearInterval(timer);
        if (launcher) location.href = (french ? '/fr' : '') + '/pages/visit-us-contact';
      }
    }, 300);
  }
  function ready() {
    removeLauncher();
    const chat = window.leadConnector && window.leadConnector.chatWidget;
    if (openAfterLoad && chat && chat.openWidget) chat.openWidget();
    openAfterLoad = false;
  }
  window.addEventListener('LC_chatWidgetLoaded', ready);
  function showLauncher() {
    if (launcher || loaded) return;
    launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'yj-chat-launcher';
    launcher.setAttribute('aria-label', label);
    launcher.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" focusable="false"><path fill="currentColor" d="M4 4h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H9l-5 4v-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/></svg>';
    launcher.style.cssText = 'position:fixed;right:20px;bottom:20px;z-index:2147483000;width:56px;height:56px;padding:0;border:0;border-radius:50%;background:#2a1e1a;color:#f7f1e8;cursor:pointer;box-shadow:0 4px 14px rgba(42,30,26,.3);display:flex;align-items:center;justify-content:center;';
    launcher.addEventListener('click', () => {
      openAfterLoad = true;
      launcher.disabled = true;
      launcher.style.opacity = '0.6';
      load();
    });
    document.body.appendChild(launcher);
  }
  function sync() {
    if (allowed()) {
      removeLauncher();
      load();
    } else {
      showLauncher();
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('a[href$="#cookie-preferences"]');
    if (!link || !window.privacyBanner || !window.privacyBanner.showPreferences) return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });
  document.addEventListener('visitorConsentCollected', sync);
  function start() {
    if (window.Shopify && window.Shopify.customerPrivacy) sync();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (error) showLauncher(); else sync();
      });
    } else showLauncher();
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, {once: true});
})();
